function topic_flood_alarm(){
	var alert_container = {
		rain: {},
		debris: {},
		stage: {}
	};
	var alert_sum = {
		rain: {total: 0, red: 0, yellow: 0, normal: 0, grey: 0},
		debris: {total: 0, red: 0, yellow: 0, normal: 0},
		stage: {total: 0, red: 0, purple: 0, yellow: 0, normal: 0},
		jiufen: {total: 0, red: 0, normal: 0},
		flash: {total: 29, red: 0, yellow: 0, list: {} }
	};
    var stage_realtime = raw_data["水利署水位"]
	stage_realtime.forEach(function(element){
		var thisRegion = element.location_address.slice(3,6)
		if (alert_container.stage[thisRegion] == undefined) {
			alert_container.stage[thisRegion] = {red: 0, purple: 0, yellow: 0, normal: 0};
		}
		var time_lag = get_now_time_UTC() - time_sql_processing(element.time);
		if (time_lag > 3600000 * 2) {
			alert_container.stage[thisRegion]["normal"] += 1;
			alert_sum.stage["normal"] += 1;
		} else {
			switch(true){
				case (element.water_level >= element.alert_level_3 && element.water_level < element.alert_level_2 && element.alert_level_2 != null && element.alert_level_3 != null):
					alert_container.stage[thisRegion]["yellow"] += 1;
					alert_sum.stage["yellow"] += 1;
					break;
				case (element.water_level >= element.alert_level_2 && element.water_level < element.alert_level_1 && element.alert_level_2 != null && element.alert_level_1 != null):
					alert_container.stage[thisRegion]["purple"] += 1;
					alert_sum.stage["purple"] += 1;
					break;
				case (element.water_level >= element.alert_level_1 && element.alert_level_1 != null):
					alert_container.stage[thisRegion]["red"] += 1;
					alert_sum.stage["red"] += 1;
					break;
				default:
					alert_container.stage[thisRegion]["normal"] += 1;
					alert_sum.stage["normal"] += 1;
			}
		}
		alert_sum.stage["total"] += 1;
	});
	
	var data_container = {
		pump: {},
		mobile_pump: {},
		water_door: {}
	};
	var data_sum = {
		pump: {total: 0, work: 0, unwork: 0, disabled: 0},
		mobile_pump: {total: 0, work: 0, standby: 0, moving: 0, unwork: 0, disabled: 0, other: 0},
		water_door: {total: 0, open: 0, close: 0}
	};
	var pump_realtime_data = raw_data["抽水站"], time_lag;
	pump_realtime_data.forEach(function(element){
		if (data_container.pump[element.town_name] == undefined) {
			data_container.pump[element.town_name] = {work: 0, unwork: 0, disabled: 0}
		}
		var status_condition;
		if (element.status != undefined) {
			time_lag = get_now_time_UTC() - time_sql_processing(element.time);
			if (time_lag > 3600000 * 2) {
				data_container.pump[element.town_name].disabled += 1;
				data_sum.pump.disabled += 1;
			} else {
				var status_array = element.status.split("|");
				status_array.forEach(function(element){
					if (element == "1") {
						status_condition = true;
					}
				})
				switch(status_condition){
					case true:
						data_container.pump[element.town_name].work += 1;
						data_sum.pump.work += 1;
						break;
					case undefined:
						data_container.pump[element.town_name].unwork += 1;
						data_sum.pump.unwork += 1;
						break;
				}
			}
			data_sum.pump.total += 1
		}
	})

	var ntc_geojson = overlay_dataset["Basic_map"],
		mobile_pump_realtime_data = raw_data["移動抽水機"];
	mobile_pump_realtime_data.forEach(function(element){
		var point = turf.point([element._lon, element._lat]);
		var in_which_region, boolean;
		ntc_geojson.features.forEach(function(each_layer){
			boolean = turf.booleanPointInPolygon(point, each_layer);
			if (boolean) {
				in_which_region = each_layer.properties.TOWNNAME
			}
		});
		switch(in_which_region){
			case undefined:
				if (data_container.mobile_pump["非新北"] == undefined) {
					data_container.mobile_pump["非新北"] = {work: 0, standby: 0, moving: 0, unwork: 0, disabled: 0, other: 0};
				}
				data_container.mobile_pump["非新北"][mobile_pump_status_handler(element._status)] += 1;
				break;
			default:
				if (data_container.mobile_pump[in_which_region] == undefined) {
					data_container.mobile_pump[in_which_region] = {work: 0, standby: 0, moving: 0, unwork: 0, disabled: 0, other: 0};
				}
				data_container.mobile_pump[in_which_region][mobile_pump_status_handler(element._status)] += 1;
		}
		data_sum.mobile_pump[mobile_pump_status_handler(element._status)] += 1;
		data_sum.mobile_pump.total += 1;
	});

	var water_door_realtime_data = raw_data["橫移門"];
	var water_door_basic_data = raw_data["wrs_gate_basic"];
	var water_door_realtime_list = {};
	try {
		water_door_realtime_data.forEach(function(element){
			water_door_realtime_list[element.Gate_No] = element;
		});
		water_door_basic_data.forEach(function(element){
			if (data_container.water_door[element.ADDR_C.slice(0,3)] == undefined) {
				data_container.water_door[element.ADDR_C.slice(0,3)] = {open: 0, close: 0};
			}
			var this_status = water_door_realtime_list[element.Gate_No].OpenClose;
			if (this_status.length != 0) {
				var string_raw = this_status.split("|");
				if (string_raw[0] == "0") {
					this_status = "0";
				} else {
					this_status = "1";
				}
			}
			switch(this_status){
				case "1":
					data_container.water_door[element.ADDR_C.slice(0,3)].open += 1;
					data_sum.water_door.open += 1;
					break;
				case "0":
					data_container.water_door[element.ADDR_C.slice(0,3)].close += 1;
					data_sum.water_door.close += 1;
					break;
			}
			data_sum.water_door.total += 1;
		});
	} catch (e) {}

	$("#flood-cardbody").html(
		slider_card_component_create({
			"cardhead": "路面淹水感知器監測",
			"cardbody": 
				'<div class="col-6 text-center flooding-sensor-alert-text" target-key="淹水"></div>'+
				'<div class="col-6 text-center flooding-sensor-alert-text" target-key="積水"></div>'+
				'<div class="col-6 text-center flooding-sensor-alert-text" target-key="未達"></div>'+
				'<div class="col-6 text-center flooding-sensor-alert-text" target-key="離線"></div>'+
				'<div class="col-12 h-280" id="flood-sensor-sta-chart"></div>'+
				'<div class="col-12">' +
					'<table class="table table-sm table-pointer w-100 table-not-new-line" id="flood-sensor-table">' +
						'<thead class="thead-dark">' +
							'<tr>' +
								'<th>站名</th>' +
								'<th>時間</th>' +
								'<th>深度</th>' +
								'<th>狀態</th>' +
							'</tr>' +
						'</thead>' +
						'<tbody></tbody>' +
					'</table>' +
				'</div>'
		}) +
		slider_card_component_create({
			"cardhead": "水位示警統計資訊(央管)",
			"cardbody": 
				'<div class="col-6 text-center">'+
					'<h5>一級' + alert_sum.stage["red"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-red stage-red-bar" role="progressbar" aria-valuenow="' + (alert_sum.stage["red"]/alert_sum.stage["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>二級' + alert_sum.stage["purple"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-purple stage-purple-bar" role="progressbar" aria-valuenow="' + (alert_sum.stage["purple"]/alert_sum.stage["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>三級' + alert_sum.stage["yellow"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-yellow stage-yellow-bar" role="progressbar" aria-valuenow="' + (alert_sum.stage["yellow"]/alert_sum.stage["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>未達' + alert_sum.stage["normal"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-green stage-normal-bar" role="progressbar" aria-valuenow="' + (alert_sum.stage["normal"]/alert_sum.stage["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="stage_sta" class="col-12 h-280"></div>'
		}) +
		slider_card_component_create({
			"cardhead": "抽水站運作統計資訊",
			"cardbody": 
				'<div class="col-4 text-center">'+
					'<h5>運作中' + data_sum.pump["work"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar pump-work-bar bg-alert-red" role="progressbar" aria-valuenow="' + (data_sum.pump["work"]/data_sum.pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>待命中' + data_sum.pump["unwork"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar pump-unwork-bar bg-alert-green" role="progressbar" aria-valuenow="' + (data_sum.pump["unwork"]/data_sum.pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>回傳中斷' + data_sum.pump["disabled"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar pump-disabled-bar bg-alert-grey" role="progressbar" aria-valuenow="' + (data_sum.pump["disabled"]/data_sum.pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="pump_sta" class="col-12 h-280"></div>'
		}) +
		slider_card_component_create({
			"cardhead": "移動抽水機運作統計資訊",
			"cardbody": 
				'<div class="col-4 text-center">'+
					'<h5>運作' + data_sum.mobile_pump["work"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar mobile_pump-work-bar bg-alert-red" role="progressbar" aria-valuenow="' + (data_sum.mobile_pump["work"]/data_sum.mobile_pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>待命' + data_sum.mobile_pump["standby"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar mobile_pump-standby-bar bg-alert-green" role="progressbar" aria-valuenow="' + (data_sum.mobile_pump["standby"]/data_sum.mobile_pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>移動' + data_sum.mobile_pump["moving"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar mobile_pump-moving-bar bg-alert-blue" role="progressbar" aria-valuenow="' + (data_sum.mobile_pump["moving"]/data_sum.mobile_pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>離線' + data_sum.mobile_pump["unwork"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar mobile_pump-unwork-bar bg-alert-yellow" role="progressbar" aria-valuenow="' + (data_sum.mobile_pump["unwork"]/data_sum.mobile_pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>故障' + data_sum.mobile_pump["disabled"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar mobile_pump-disabled-bar bg-alert-grey" role="progressbar" aria-valuenow="' + (data_sum.mobile_pump["disabled"]/data_sum.mobile_pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>其它' + data_sum.mobile_pump["other"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar mobile_pump-other-bar bg-alert-black" role="progressbar" aria-valuenow="' + (data_sum.mobile_pump["other"]/data_sum.mobile_pump["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="mobile_pump_sta" class="col-12 h-280"></div>'
		}) +
		slider_card_component_create({
			"cardhead": "橫移門開關統計資訊",
			"cardbody": 
				'<div class="col-6 text-center">'+
					'<h5>開啟中' + data_sum.water_door["open"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar water_door-open-bar bg-alert-green" role="progressbar" aria-valuenow="' + (data_sum.water_door["open"]/data_sum.water_door["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>關閉中' + data_sum.water_door["close"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar water_door-close-bar bg-alert-red" role="progressbar" aria-valuenow="' + (data_sum.water_door["close"]/data_sum.water_door["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="water_door_sta" class="col-12 h-280"></div>'
		})
	)

	for (var category in data_sum) {
		for (var level in data_sum[category]) {
			$("." + category + "-" + level + "-bar").css("width", (data_sum[category][level] / data_sum[category]["total"])*100 + "%")	
		}
	}
	stacked_percent_chart({
		div: "pump_sta",
		data: data_container.pump,
		key_name: ["work", "unwork", "disabled"],
		label: ["運作", "停止", "回傳中斷"],
		color: ['#e85a71', '#3ac569', "#a3a1a1"]
	});
	stacked_percent_chart({
		div: "mobile_pump_sta",
		data: data_container.mobile_pump,
		key_name: ["work", "standby", "moving", "unwork", "disabled", "other"],
		label: ["運作", "待命", "移動", "離線", "故障", "其它"],
		color: ['#e85a71', '#3ac569', '#30A9DE', '#FFBC42', '#a3a1a1', '#282c37']
	});
	stacked_percent_chart({
		div: "water_door_sta",
		data: data_container.water_door,
		key_name: ["open", "close"],
		label: ["開啟", "關閉"],
		color: ['#3ac569', '#e85a71']
	});


	for (var category in alert_sum) {
		for (var level in alert_sum[category]) {
			$("." + category + "-" + level + "-bar").css("width", (alert_sum[category][level] / alert_sum[category]["total"])*100 + "%")	
		}
	}
	stacked_percent_chart({
		div: "stage_sta",
		data: alert_container.stage,
		key_name: ["red", "purple", "yellow", "normal"],
		label: ["一級", "二級", "三級", "未達"],
		color: ['#e85a71', '#9055A2', '#FFBC42', '#3ac569']
	});


	function floodingSensorPage(){
		let sumData = {
				total: 0,
				alert: {
					"淹水": {
						color: "red",
						total: 0
					},
					"積水": {
						color: "yellow",
						total: 0
					},
					"未達": {
						color: "green",
						total: 0
					},
					"離線": {
						color: "grey",
						total: 0
					}
				},
				region: {}
			},
			html = {
				table: ""
			}
		// 數據處理
		raw_data["淹水感知器"].features.forEach(feature => {
			let thisStatus = feature.properties.status
			// 總示警數據
			sumData.total += 1
			sumData.alert[thisStatus].total += 1
			// 區域示警數據
			if (!sumData.region[feature.properties.townname]) {
				sumData.region[feature.properties.townname] = { "淹水": 0, "積水": 0, "未達": 0, "離線": 0 }	
			}
			sumData.region[feature.properties.townname][thisStatus] += 1
			// 表格html
			html.table += `
				<tr lon="${feature.geometry.coordinates[0]}" lat="${feature.geometry.coordinates[1]}">
					<td>${feature.properties.st_name}</td>
					<td>${feature.properties.time}</td>
					<td>${feature.properties.level}cm</td>
					<td>${feature.properties.status}</td>
				</tr>`
		})
		// 百分比統計圖
		stacked_percent_chart({
			div: "flood-sensor-sta-chart",
			data: sumData.region,
			key_name: ["淹水", "積水", "未達", "離線"],
			label: ["淹水", "積水", "未達", "離線"],
			color: ['#e85a71', '#FFBC42', '#3ac569', '#ced4da']
		})
		// 總示警數據render
		$("div.flooding-sensor-alert-text").each(function(){
			let targetKey = $(this).attr("target-key"),
				thisAlert = sumData.alert[targetKey],
				thisColor = sumData.alert[targetKey].color,
				thisPercent = (thisAlert.total/sumData.total) * 100
			$(this).html(`
				<h5>${targetKey}${thisAlert.total}處</h5>
				<div class="progress mb-2 mt-2">
					<div class="progress-bar bg-alert-${thisColor}" role="progressbar" aria-valuenow="${thisPercent}" aria-valuemin="0" aria-valuemax="100" style="width: ${thisPercent}%;"></div>
				</div>`
			)
		})
		// 表格render
		setTimeout(function(){
			$("#flood-sensor-table tbody").html(html.table)
			$("#flood-sensor-table").DataTable({
				scrollX: true
			})
			$("#flood-sensor-table tbody").on("click", "tr", function(){
				let thisLocation = {
					lon: Number($(this).attr("lon")),
					lat: Number($(this).attr("lat"))
				}
				map.setView([thisLocation.lat, thisLocation.lon], 18)
			})
		}, 500)
	}
	floodingSensorPage()
}
